import React from 'react';
import { KivlopeLogo } from '../components/Icons';

const LoadingScreen = ({ message = "Loading your memories..." }) => (
  <div className="bg-[#121212] text-[#EAEAEA] min-h-screen flex items-center justify-center">
    <div className="text-center">
      <KivlopeLogo />
      <h1 className="text-4xl text-[#D4AF37] animate-pulse mt-4 font-serif">Kivlope</h1>
      <p className="text-[#A0A0A0]">{message}</p>
    </div>
  </div>
);

export default LoadingScreen;
